import { render } from "./Home.vue?vue&type=template&id=00aa1d90&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=00aa1d90&lang=scss&scoped=true"

import exportComponent from "/Users/normglomski/projects/vue/pomcs.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00aa1d90"]])

export default __exports__